module.exports = __webpack_public_path__ + "assets/img/portfolio.18e54116.png";